import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState("/");
  const [hoverItem, setHoverItem] = useState(null);
  const [openSpecialities, setOpenSpecialities] = useState(false);
  const [openEyeServices, setOpenEyeServices] = useState(false);
  const [openOrthoServices, setOpenOrthoServices] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setIsOpen(!isOpen);
  };

  // Toggle specialities dropdown
  const toggleSpecialities = (e) => {
    e.preventDefault(); // Prevent navigation when clicking the dropdown toggle
    setOpenSpecialities(!openSpecialities);
  };

  // Handle active link
  const handleLinkClick = (path) => {
    setActiveLink(path);
    setIsOpen(false);
    // Don't close the dropdowns when navigating to related pages
    if (!path.startsWith("/services")) {
      setOpenSpecialities(false);
      setOpenEyeServices(false);
      setOpenOrthoServices(false);
    }
  };

  // Nav items with icons - Rearranged to place Specialities as the 3rd option
  const navItems = [
    { name: "Home", path: "/", icon: "home" },
    { name: "About", path: "/about", icon: "info" },
    { name: "Specialities", path: "/specialities", icon: "briefcase" }, // Added Specialities as 3rd item
    { name: "Contact", path: "/contact", icon: "phone" },
    { name: "Gallery", path: "/gallery", icon: "image" },
    { name: "Review", path: "/review", icon: "star" }
  ];

  // Specialities dropdown items with added parent links
  const specialitiesItems = {
    eyeServices: [
      { name: "Phacoemulsification (Phaco Surgery)", path: "/eye-services/1" },
      { name: "Cataract Surgery", path: "/eye-services/2" },
      { name: "Diabetic Retinopathy", path: "/eye-services/3" },
      { name: "Cornea and Associated Diseases", path: "/eye-services/4" },
      { name: "Glaucoma Treatment", path: "/eye-services/5" },
      { name: "Neuro-Ophthalmology", path: "/eye-services/6" },
      { name: "Oculoplasty", path: "/eye-services/7" },
      { name: "Pediatric Ophthalmology", path: "/eye-services/8" },
      { name: "Refractive Surgeries", path: "/eye-services/9" },
      { name: "Retina and Associated Diseases", path: "/eye-services/10" },
      { name: "LASIK Surgery", path: "/eye-services/11" },
      { name: "ICL Eye Surgery", path: "/eye-services/12" },
      { name: "Photorefractive Keratectomy", path: "/eye-services/13" },
      { name: "Squint Eye", path: "/eye-services/14" },
    ],
    orthoServices: [
      { name: "Trauma Surgeries  ", path: "/ortho-services/1" },
      { name: "Knee Replacement Surgeries  ", path: "/ortho-services/2" },
      { name: "Hip Replacement Surgeries  ", path: "/ortho-services/3" },
      { name: "Shoulder Surgeries  ", path: "/ortho-services/4" },
      { name: "Spine Surgeries ", path: "/ortho-services/5" },
      { name: "Foot & Ankle Surgeries  ", path: "/ortho-services/6" },
      { name: "Pediatric Orth. Surgeries  ", path: "/ortho-services/7" },
      { name: "Arthroscopies Surgery", path: "/ortho-services/8" }
    ]
  };

  return (
    <div className="flex flex-col">
  <header 
    className={`fixed w-full top-0 z-50 mb-8 ${
      scrolled 
        ? "bg-gradient-to-b from-sky-700 to-sky-800 shadow-lg py-2" 
        : "bg-gradient-to-b from-sky-700 to-sky-800 py-4"
    }`}
  >
<div className="container mx-auto px-2 sm:px-8 flex justify-between items-center">
  {/* Logo Section with animation - REVISED FOR RESPONSIVE DESIGN */}
  <div className="flex items-center flex-shrink-0 mr-auto pr-2 sm:pr-4">
    <Link 
      to="/"
      onClick={() => handleLinkClick("/")}
    >
      <div className="flex items-center "> {/* Changed to match the title's spacing */}
        {/* First logo */}
        <div className="relative overflow-hidden">
          <img
            src="images/logoA.png"
            alt="logo"
            className="w-[50px] h-[50px] max-w-none object-contain relative z-6"
          />
        </div>
      </div>
    </Link>

    {/* IMPROVED RESPONSIVE TITLE WITH INLINE LOGO */}
    <div className="flex items-center py-1 px-1 sm:py-2 sm:px-3 rounded-lg">
      <div className="relative overflow-hidden py-0 sm:py-1 px-1 sm:px-2">
        {/* Glow effects */}
        <div className="absolute -inset-1/2 top-0 left-0 w-12 h-12 bg-white opacity-10 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute -inset-1/2 bottom-0 right-0 w-12 h-12 bg-blue-300 opacity-10 rounded-full blur-xl animate-pulse delay-700"></div>
        
        {/* Main heading with logo after */}
        <div className="flex items-center space-x-2 sm:space-x-4 relative z-10">
          <h1 className="font-sans font-bold text-sm xs:text-base sm:text-xl md:text-2xl lg:text-3xl text-white text-center tracking-wide
            drop-shadow-[0_2px_4px_rgba(0,0,0,0.3)]
            transition-all duration-500 
            hover:tracking-wider
            hover:drop-shadow-[0_4px_8px_rgba(255,255,255,0.4)]">

            <span className="relative inline-block
              before:absolute before:left-0 before:-bottom-1 sm:before:-bottom-2 before:w-0 before:h-0.5 
              before:bg-white before:transition-all before:duration-500
              after:absolute after:right-0 after:-bottom-1 sm:after:-bottom-2 after:w-0 after:h-0.5
              after:bg-white after:transition-all after:duration-500
              hover:before:w-1/2 hover:after:w-1/2">
              <span className="">Unity Ortho and Eye Hospital</span>
            </span>
          </h1>

          {/* Second logo after title */}
          <div className="relative overflow-hidden ">
            <img
              src="images/unity hospital logo 1312312.png"
              alt="logo"
              className="w-[40px] h-[40px] mt-[4px] max-w-none object-contain relative z-6"
            />
          </div>
        </div>

        {/* Tagline */}
        <p className="text-blue-100 mt-0 sm:mt-2 text-center text-xs md:text-sm font-medium tracking-wider">
          <span className="hidden xs:inline">Advanced Care for Your Vision &amp; Orthopedic Health</span>
        </p>
      </div>
    </div>
  </div>




          {/* Hamburger for mobile with animation */}
          <div className="md:hidden">
            <button 
              onClick={toggleMobileMenu} 
              className="text-white focus:outline-none transition-all duration-300 hover:scale-110 relative"
              aria-label="Toggle menu"
            >
              <div className={`w-6 h-6 flex items-center justify-center overflow-hidden`}>
                <div className={`transform transition-all duration-500 relative ${isOpen ? 'rotate-180' : 'rotate-0'}`}>
                  {isOpen ? (
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  ) : (
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  )}
                </div>
              </div>
              <span className={`absolute -bottom-1 left-0 w-full h-0.5 bg-white transform origin-center transition-all duration-300 ${
                isOpen ? 'scale-x-100' : 'scale-x-0'
              }`}></span>
            </button>
          </div>

          {/* Nav Links with enhanced hover effects */}
          <ul className="hidden md:flex space-x-4 text-sm font-semibold text-white">
            {navItems.map((item) => {
              // Handle specialities menu differently
              if (item.name === "Specialities") {
                return (
                  <li key={item.name} className="relative">
                    <div className="flex flex-col">
                      <div className="flex items-center">
                        {/* Navigate to Specialities Page */}
                        <Link
                          to={item.path}
                          onClick={(e) => {
                            if (!openSpecialities) {
                              e.preventDefault(); // Prevent navigation on first click to open dropdown
                              toggleSpecialities(e);
                            } else {
                              handleLinkClick(item.path); // Navigate on second click if dropdown is open
                            }
                          }}
                          className={`px-3 py-2 relative overflow-hidden group transition-all duration-300 flex items-center ${
                            activeLink === item.path || activeLink.startsWith("/services") 
                              ? "text-white font-bold" 
                              : "text-white-50"
                          }`}
                          onMouseEnter={() => setOpenSpecialities(true)}
                          onMouseLeave={() => {
                            // Only close if not hovering any submenu
                            if (!openEyeServices && !openOrthoServices) {
                              setOpenSpecialities(false);
                            }
                          }}
                        >
                          {/* Icon for specialities */}
                          <span className="mr-1">
                            <svg className="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                            </svg>
                          </span>
                          
                          <span className="relative z-10 group-hover:text-white transition-all duration-300">
                            {item.name}
                            <span className={`absolute -bottom-1 left-0 w-full h-0.5 bg-white transform origin-left transition-all duration-300 ${
                              activeLink === item.path || activeLink.startsWith("/services") ? "scale-x-100" : "scale-x-0"
                            } group-hover:scale-x-100`}></span>
                          </span>
                          
                          <span className="absolute inset-0 bg-sky-500 transform scale-y-0 group-hover:scale-y-100 transition-transform duration-300 rounded-lg opacity-0 group-hover:opacity-40"></span>
                          
                          {(activeLink === item.path || activeLink.startsWith("/services")) && (
                            <span className="absolute -bottom-1 left-1/2 w-1.5 h-1.5 bg-white rounded-full transform -translate-x-1/2 animate-pulse"></span>
                          )}
                        </Link>
                        
                        {/* Dropdown Toggle Button */}
                        <button 
                          onClick={toggleSpecialities}
                          className="ml-1 text-white focus:outline-none p-1 rounded-full hover:bg-sky-600 transition-all duration-300"
                          aria-label="Toggle Specialities Menu"
                        >
                          <svg 
                            className={`w-4 h-4 transition-transform duration-300 ${openSpecialities ? 'rotate-180' : 'rotate-0'}`} 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </button>
                      </div>
                    </div>
                    
                    {/* Specialities dropdown menu */}
                    {openSpecialities && (
                      <div 
                        className="absolute left-0 mt-2 w-56 bg-white rounded-md shadow-lg py-1 z-50" 
                        onMouseEnter={() => setOpenSpecialities(true)}
                        onMouseLeave={() => {
                          setOpenSpecialities(false);
                          setOpenEyeServices(false);
                          setOpenOrthoServices(false);
                        }}
                      >
                        {/* Eye Services */}
                        <div 
                          className="relative"
                          onMouseEnter={() => setOpenEyeServices(true)}
                          onMouseLeave={() => setOpenEyeServices(false)}
                        >
                          {/* Make Eye Services clickable */}
                          <Link
                            to="/specialities"
                            onClick={() => handleLinkClick("/specialities")}
                            className="px-4 py-2 text-gray-800 hover:bg-sky-50 flex justify-between items-center cursor-pointer block"
                          >
                            <span>Eye Care</span>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                          </Link>
                          
                          {/* Eye Services submenu */}
                          {openEyeServices && (
                            <div className="absolute left-full top-0 ml-1 w-56 bg-white rounded-md shadow-lg py-1 z-50">
                              {specialitiesItems.eyeServices.map((service) => (
                                <Link
                                  key={service.name}
                                  to={service.path}
                                  onClick={() => handleLinkClick(service.path)}
                                  className={`block px-4 py-2 text-gray-800 hover:bg-sky-50 ${
                                    activeLink === service.path ? "bg-sky-100 text-sky-600" : ""
                                  }`}
                                >
                                  {service.name}
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                        
                        {/* Ortho Services */}
                        <div 
                          className="relative"
                          onMouseEnter={() => setOpenOrthoServices(true)}
                          onMouseLeave={() => setOpenOrthoServices(false)}
                        >
                          {/* Make Ortho Services clickable */}
                          <Link
                            to="/specialities"
                            onClick={() => handleLinkClick("/specialities")}
                            className="px-4 py-2 text-gray-800 hover:bg-sky-50 flex justify-between items-center cursor-pointer block"
                          >
                            <span>Ortho Care</span>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                          </Link>
                          
                          {/* Ortho Services submenu */}
                          {openOrthoServices && (
                            <div className="absolute left-full top-0 ml-1 w-56 bg-white rounded-md shadow-lg py-1 z-50">
                              {specialitiesItems.orthoServices.map((service) => (
                                <Link
                                  key={service.name}
                                  to={service.path}
                                  onClick={() => handleLinkClick(service.path)}
                                  className={`block px-4 py-2 text-gray-800 hover:bg-sky-50 ${
                                    activeLink === service.path ? "bg-sky-100 text-sky-600" : ""
                                  }`}
                                >
                                  {service.name}
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </li>
                );
              }
              
              // Regular nav items
              return (
                <li key={item.name}>
                  <Link 
                    to={item.path} 
                    onClick={() => handleLinkClick(item.path)}
                    onMouseEnter={() => setHoverItem(item.name)}
                    onMouseLeave={() => setHoverItem(null)}
                    className={`px-3 py-2 relative overflow-hidden group transition-all duration-300 flex items-center ${
                      activeLink === item.path ? "text-white font-bold" : "text-white-50"
                    }`}
                  >
                    {/* Icon based on item */}
                    <span className="mr-1">
                      {item.icon === "home" && (
                        <svg className="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                        </svg>
                      )}
                      {item.icon === "info" && (
                        <svg className="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      )}
                      {item.icon === "phone" && (
                        <svg className="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                      )}
                      {item.icon === "image" && (
                        <svg className="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                      )}
                      {item.icon === "star" && (
                        <svg className="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                        </svg>
                      )}
                    </span>
                    
                    {/* Text with hover animation */}
                    <span className="relative z-10 group-hover:text-white transition-all duration-300">
                      {item.name}
                      <span className={`absolute -bottom-1 left-0 w-full h-0.5 bg-white transform origin-left transition-all duration-300 ${
                        activeLink === item.path ? "scale-x-100" : "scale-x-0"
                      } group-hover:scale-x-100`}></span>
                    </span>
                    
                    {/* Background animation */}
                    <span className="absolute inset-0 bg-sky-500 transform scale-y-0 group-hover:scale-y-100 transition-transform duration-300 rounded-lg opacity-0 group-hover:opacity-40"></span>
                    
                    {/* Pill indicator for active state */}
                    {activeLink === item.path && (
                      <span className="absolute -bottom-1 left-1/2 w-1.5 h-1.5 bg-white rounded-full transform -translate-x-1/2 animate-pulse"></span>
                    )}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Mobile Menu with improved animation */}
        <div 
          className={`md:hidden transition-all duration-500 ease-in-out ${
            isOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
          } overflow-hidden`}
        >
          <ul className="px-2 py-2 space-y-1 text-sm font-semibold bg-white rounded-b-xl shadow-xl mx-2 mt-2 border-t-2 border-sky-200">
            {navItems.map((item) => {
              // Special handling for Specialities in mobile menu
              if (item.name === "Specialities") {
                return (
                  <li 
                    key={item.name} 
                    className="transform transition-all duration-300"
                  >
                    <div className="flex flex-col">
                      <div className="flex items-center justify-between">
                        {/* Specialities link */}
                        <Link 
                          to={item.path}
                          onClick={() => handleLinkClick(item.path)}
                          className={`flex items-center py-2 px-1 transition-all duration-300 hover:bg-sky-50 rounded-lg ${
                            activeLink === item.path || activeLink.startsWith("/services")
                              ? "text-sky-600 font-bold bg-sky-50" 
                              : "text-sky-700"
                          }`}
                        >
                          <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-2 transition-all duration-300 ${
                            activeLink === item.path || activeLink.startsWith("/services") ? "bg-sky-500 text-white" : "bg-sky-100 text-sky-500"
                          }`}>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                            </svg>
                          </div>
                          {item.name}
                        </Link>
                        
                        {/* Dropdown toggle button */}
                        <button
                          onClick={() => setOpenSpecialities(!openSpecialities)}
                          className="py-2 px-1 text-sky-700 focus:outline-none"
                        >
                          <svg 
                            className={`w-6 h-6 transition-transform duration-300 ${openSpecialities ? 'rotate-180' : 'rotate-0'}`} 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </button>
                      </div>
                    </div>
                    
                    {/* Mobile submenus */}
                    {openSpecialities && (
                      <div className="pl-4 mt-2">
                        {/* Eye Services */}
                        <div className="mb-2">
                          {/* Make Eye Services clickable */}
                          <Link
                            to="/specialities"
                            onClick={() => handleLinkClick("/specialities")}
                            className="flex items-center py-2 px-2 transition-all duration-300 hover:bg-sky-50 rounded-lg text-sky-700 cursor-pointer"
                          >
                            <div className="w-6 h-6 rounded-full flex items-center justify-center mr-3 bg-sky-100 text-sky-500">
                              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                              </svg>
                              </div>
                            Eye Care
                          </Link>
                          
                          {/* Eye Services List */}
                          <div className="bg-sky-50 rounded-lg mt-1 pl-2">
                            {specialitiesItems.eyeServices.map((service) => (
                              <Link
                                key={service.name}
                                to={service.path}
                                onClick={() => handleLinkClick(service.path)}
                                className={`block py-2 px-8 text-sm transition-all duration-300 ${
                                  activeLink === service.path ? "text-sky-600 font-semibold" : "text-sky-700"
                                } hover:text-sky-600`}
                              >
                                {service.name}
                              </Link>
                            ))}
                          </div>
                        </div>
                        
                        {/* Ortho Services */}
                        <div>
                          {/* Make Ortho Services clickable */}
                          <Link
                            to="/specialities"
                            onClick={() => handleLinkClick("/specialities")}
                            className="flex items-center py-2 px-2 transition-all duration-300 hover:bg-sky-50 rounded-lg text-sky-700 cursor-pointer"
                          >
                            <div className="w-6 h-6 rounded-full flex items-center justify-center mr-3 bg-sky-100 text-sky-500">
                              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                              </svg>
                            </div>
                            Ortho Care
                          </Link>
                          
                          {/* Ortho Services List */}
                          <div className="bg-sky-50 rounded-lg mt-1 pl-2">
                            {specialitiesItems.orthoServices.map((service) => (
                              <Link
                                key={service.name}
                                to={service.path}
                                onClick={() => handleLinkClick(service.path)}
                                className={`block py-2 px-8 text-sm transition-all duration-300 ${
                                  activeLink === service.path ? "text-sky-600 font-semibold" : "text-sky-700"
                                } hover:text-sky-600`}
                              >
                                {service.name}
                              </Link>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                );
              }
              
              // Regular mobile nav items
              return (
                <li 
                  key={item.name} 
                  className={`transform transition-all duration-300 ${
                    activeLink === item.path ? "translate-x-1" : "translate-x-0"
                  }`}
                >
                  <Link 
                    to={item.path} 
                    onClick={() => handleLinkClick(item.path)}
                    className={`flex items-center py-2 px-1 rounded-lg transition-all duration-300 hover:bg-sky-50 ${
                      activeLink === item.path ? "text-sky-600 font-bold bg-sky-50" : "text-sky-700"
                    }`}
                  >
                    <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-2 transition-all duration-300 ${
                      activeLink === item.path ? "bg-sky-500 text-white" : "bg-sky-100 text-sky-500"
                    }`}>
                      {item.icon === "home" && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                        </svg>
                      )}
                      {item.icon === "info" && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      )}
                      {item.icon === "phone" && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                      )}
                      {item.icon === "image" && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                      )}
                      {item.icon === "star" && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                        </svg>
                      )}
                    </div>
                    {item.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </header>
      
      {/* Spacer to push content below the fixed header */}
      <div className={`${scrolled ? "pt-16" : "pt-20"} transition-all duration-500`}></div>
      
      {/* Render nested routes */}
      {/* <main className="flex-grow">
        <Outlet />
      </main> */}
    </div>
  );
};

export default Navbar;